import { FC, useContext } from "react";

import { SubscriptionContext } from "src/services/SubscriptionService";
import { STATE_MAP } from "src/constants";

export const DisplayIfLegalState: FC<Props> = ({ children }) => {
  const ctx = useContext(SubscriptionContext);
  const isUserInLegalState = STATE_MAP[ctx.userLocale]?.legal;

  if (!isUserInLegalState) {
    return null;
  }
  return children;
};

interface Props {
  children: JSX.Element;
}
